
import { Vue } from "vue-class-component";

export default class PodDex extends Vue {}
